import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PasswordValidators {
    public static passwordMatchValidator(): ValidatorFn {
        return (currentControl: AbstractControl): { [key: string]: any } | null => {
            if (!currentControl.get('password') || !currentControl.get('passwordConfirm')) {
                return null;
            }
            const password: string = currentControl.get('password').value;
            const confirmPassword: string = currentControl.get('passwordConfirm').value;
            if (password && confirmPassword && password !== confirmPassword) {
                return { wrongPassword: true };
            }
            return null;
        };
    }

    public static passwordFormatValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (!control.value) {
                return null;
            }
            // Minimum 8 caractères dont min. 1 majuscle, 1 minuscules, 1 chiffres, 1 caractère special
            if (control.value.match(/(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^A-Za-z0-9]).{8,}/)) {
                return null;
            } else {
                return { wrongFormat: true };
            }
        };
    }

    public static allPasswordPresentValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            if (!control.value.oldPassword && !control.value.passwords.password && !control.value.passwords.passwordConfirm) {
                return null;
            }
            if (control.value?.oldPassword && control.value.passwords.password && control.value.passwords.passwordConfirm) {
                if (control.value.oldPassword === control.value.passwords.password) {
                    return { samePassword: true };
                }
                if (control.value.passwords.password === control.value.passwords.passwordConfirm) {
                    return null;
                } else {
                    return { nonEqualFields: true };
                }
            } else {
                return { missingPassword: true };
            }
        };
    }
}
